// extracted by mini-css-extract-plugin
export var sliderRange = "_nh-2";
export var sliderRoot = "_nh-0";
export var sliderThumb = "_nh-3";
export var sliderTrack = "_nh-1";